import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Bento } from "@/components/landing/Bento";
import { Preview } from "@/components/landing/Preview";
import { Simulator } from "@/components/landing/Simulator";
import { Faq } from "@/components/landing/Faq";
import { Footer } from "@/components/landing/Footer";
import { StickyBar } from "@/components/landing/StickyBar";

export default function Landing() {
    return (
        <div data-testid="landing-page">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <Bento />
                <Preview />
                <Simulator />
                <Faq />
            </main>
            <Footer />
            <StickyBar />
        </div>
    );
}
